import { render, staticRenderFns } from "./MyWasteWidgetContent.vue?vue&type=template&id=37dc03bd&scoped=true"
import script from "./MyWasteWidgetContent.vue?vue&type=script&lang=js"
export * from "./MyWasteWidgetContent.vue?vue&type=script&lang=js"
import style0 from "./MyWasteWidgetContent.vue?vue&type=style&index=0&id=37dc03bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc03bd",
  null
  
)

export default component.exports